import { BudgetPhases, InscriptionStatusCategory } from 'business/constants';
import _ from 'lodash';
import {
    getAmountFromPhase,
    getFieldValueFromPhase,
    InscriptionT,
} from '../shared/entities/inscription';
import { isRejectedForPhase } from '../shared/phases/phase';

/** Remove missing inscription */
const hasPhaseInscription = (
    inscription: InscriptionT,
    phase: BudgetPhases,
): boolean => {
    if (!inscription['phases']) return false;

    const phaseInscription = inscription['phases'].find(
        (p) => p.phase === phase,
    );

    return Boolean(phaseInscription);
};

/** Retrieve the amount aggregated for a given inscription */
export const getAggAmount = (
    inscriptions: InscriptionT[],
    phase: BudgetPhases,
): number =>
    inscriptions.reduce((aggAmount, inscription) => {
        const isMissing = !hasPhaseInscription(inscription, phase);
        if (isMissing) return aggAmount;
        if (isRejectedForPhase(inscription, phase)) return aggAmount;
        const status = getFieldValueFromPhase(phase, 'status', inscription);
        if (
            phase === BudgetPhases.ARBITRAGE_DM &&
            ['voted_primitive', InscriptionStatusCategory.VOTED].includes(
                status,
            )
        )
            return aggAmount;
        const amount = getAmountFromPhase(phase, inscription) ?? 0;
        return aggAmount + amount;
    }, 0);
